"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _createSvg = require("../createSvg");

var _interfaces = require("../interfaces");

var _default = (0, _createSvg.createSvg)('IconRedo', new _interfaces.SVGIconWithSizes((0, _defineProperty2.default)({}, _interfaces.IconSize.Small, {
  paths: ['M19,7a1,1,0,0,0-.4-.78L15.17,2.79a1,1,0,0,0-1.41,0,1,1,0,0,0,0,1.42L15.55,6H7A6,6,0,0,0,7,18h3a1,1,0,0,0,0-2H7A4,4,0,0,1,7,8h8.62L13.76,9.86a1,1,0,0,0,1.41,1.42l3.54-3.54A1,1,0,0,0,19,7Z'],
  params: {
    viewBox: '0 0 20 20'
  },
  height: 20,
  width: 20
})));

exports.default = _default;